import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';
import Alert from '../common/Alert';
import Footer from './Footer';
import { GetFavorites } from '../../services/PropertyServices';
import Footer2 from './footer2';

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const baseUrl = process.env.REACT_APP_BASE_URL_DEV;
  const [likedPropertyIds, setLikedPropertyIds] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasRedirected, setHasRedirected] = useState(false); // Prevent multiple redirects

  const GetFavorite = async () => {
    setIsLoading(true);
    try {
      const data = await GetFavorites();
      const favoriteIds = Array.isArray(data.result) ? data.result.map(fav => fav.propertyId) : [];
      setLikedPropertyIds(favoriteIds);
    } catch (error) {
      console.error("Error fetching favorites:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleLike = async (propertyId) => {
    const token = localStorage.getItem("Finder-token");

    if (token) {
      try {
        setIsLoading(true);
        if (likedPropertyIds.includes(propertyId)) {
          await fetch(`${baseUrl}/api/favorites/${propertyId}`, {
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
          });
        } else {
          await fetch(`${baseUrl}/api/favorites`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ propertyId }),
          });
        }
        GetFavorite();
      } catch (error) {
        console.error("Error toggling favorite:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setLikedPropertyIds((prev) => {
        const updated = prev.includes(propertyId)
          ? prev.filter(id => id !== propertyId)
          : [...prev, propertyId];

        localStorage.setItem("likedProperties", JSON.stringify(updated));
        return updated;
      });
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("Finder-token");

    if (token) {
      const role = localStorage.getItem('userRole');
      setUserRole(role);

      const isOnHomePage = location.pathname === '/' || location.pathname === '/home';
      const isAdminOrAgent = role === 'agent' || role === 'admin';

      if (isAdminOrAgent && isOnHomePage && !hasRedirected) {
        setHasRedirected(true);
        navigate('/dashboard', { replace: true });
      } else if (!isAdminOrAgent) {
        GetFavorite(); 
      }
    } else {
      const saved = localStorage.getItem("likedProperties");
      setLikedPropertyIds(saved ? JSON.parse(saved) : []);
    }
  }, [location.pathname]);


  // useEffect(() => {
  //   const role = localStorage.getItem("userRole");
  //   setUserRole(role || ''); 
  // }, []); 
  
  useEffect(() => {
    const token = localStorage.getItem("Finder-token");
    if (!token) return;




    const localLiked = JSON.parse(localStorage.getItem("likedProperties")) || [];
    if (localLiked.length > 0) {
      const syncFavorites = async () => {
        try {
          setIsLoading(true);
          await Promise.all(
            localLiked.map((propertyId) =>
              fetch(`${baseUrl}/api/favorites`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ propertyId }),
              })
            )
          );
          localStorage.removeItem("likedProperties");
          GetFavorite();
        } catch (error) {
          console.error("Error syncing favorites:", error);
        } finally {
          setIsLoading(false);
        }
      };
      syncFavorites();
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 overflow-auto flex flex-col">
        <Outlet context={{ likedPropertyIds, toggleLike, isLoading }} />
      </main>
      <Alert />

      {
        !(userRole === "admin" || userRole === "agent") && <Footer />
      }


  {
        (userRole === "admin" || userRole === "agent") && <Footer2 />
      }
    </div>
  );
};

export default Layout;